// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import TenantBamboraSetting from "./tenant-bambora-setting.js"
import TenantContactSetting from "./tenant-contact-setting.js"
import TenantDomain from "./tenant-domain.js"
import TenantInventioSetting from "./tenant-inventio-setting.js"
import TenantShipmondoSetting from "./tenant-shipmondo-setting.js"
import TenantShopSetting from "./tenant-shop-setting.js"
import TenantUniSetting from "./tenant-uni-setting.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "default_tenant_domain_id": {
      "column": {
        "default": null,
        "name": "default_tenant_domain_id",
        "null": true,
        "type": "uuid"
      },
      "name": "default_tenant_domain_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "parent_id": {
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": "uuid"
      },
      "name": "parent_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Tenant",
  "collectionKey": "tenants",
  "collectionName": "tenants",
  "i18nKey": "tenant",
  "camelizedLower": "tenant",
  "name": "Tenant",
  "nameDasherized": "tenant",
  "pluralName": "tenants",
  "ransackable_associations": [
    {
      "className": "AbilityGroupAbility",
      "collectionName": "ability_group_abilities",
      "foreignKey": "tenant_id",
      "name": "ability_group_abilities",
      "macro": "has_many",
      "resource_name": "AbilityGroupAbility",
      "through": null
    },
    {
      "className": "AbilityGroup",
      "collectionName": "ability_groups",
      "foreignKey": "tenant_id",
      "name": "ability_groups",
      "macro": "has_many",
      "resource_name": "AbilityGroup",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "tenant_id",
      "name": "activities",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "ActivityGroup",
      "collectionName": "activity_groups",
      "foreignKey": "tenant_id",
      "name": "activity_groups",
      "macro": "has_many",
      "resource_name": "ActivityGroup",
      "through": null
    },
    {
      "className": "ActivityParticipantTypeRule",
      "collectionName": "activity_participant_type_rules",
      "foreignKey": "tenant_id",
      "name": "activity_participant_type_rules",
      "macro": "has_many",
      "resource_name": "ActivityParticipantTypeRule",
      "through": null
    },
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "tenant_id",
      "name": "activity_participants",
      "macro": "has_many",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "ActivityPermittedContactType",
      "collectionName": "activity_permitted_contact_types",
      "foreignKey": "tenant_id",
      "name": "activity_permitted_contact_types",
      "macro": "has_many",
      "resource_name": "ActivityPermittedContactType",
      "through": null
    },
    {
      "className": "ActivitySurvey",
      "collectionName": "activity_surveys",
      "foreignKey": "tenant_id",
      "name": "activity_surveys",
      "macro": "has_many",
      "resource_name": "ActivitySurvey",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "tenant_id",
      "name": "addresses",
      "macro": "has_many",
      "resource_name": "Address",
      "through": null
    },
    {
      "className": "AgendaItemElementSpeaker",
      "collectionName": "agenda_item_element_speakers",
      "foreignKey": "tenant_id",
      "name": "agenda_item_element_speakers",
      "macro": "has_many",
      "resource_name": "AgendaItemElementSpeaker",
      "through": null
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "tenant_id",
      "name": "agenda_item_elements",
      "macro": "has_many",
      "resource_name": "AgendaItemElement",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "tenant_id",
      "name": "agenda_items",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "tenant_id",
      "name": "agendas",
      "macro": "has_many",
      "resource_name": "Agenda",
      "through": null
    },
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "tenant_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": null
    },
    {
      "className": "Ckeditor::Asset",
      "collectionName": "editor_pilots",
      "foreignKey": "tenant_id",
      "name": "assets",
      "macro": "has_many",
      "resource_name": "EditorPilot",
      "through": null
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "tenant_id",
      "name": "bank_accounts",
      "macro": "has_many",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "BundleOrderLine",
      "collectionName": "bundle_order_lines",
      "foreignKey": "tenant_id",
      "name": "bundle_order_lines",
      "macro": "has_many",
      "resource_name": "BundleOrderLine",
      "through": null
    },
    {
      "className": "BundleTenantPhotoProduct",
      "collectionName": "bundle_tenant_photo_products",
      "foreignKey": "tenant_id",
      "name": "bundle_tenant_photo_products",
      "macro": "has_many",
      "resource_name": "BundleTenantPhotoProduct",
      "through": null
    },
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "tenant_id",
      "name": "bundles",
      "macro": "has_many",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "CallListEntity",
      "collectionName": "call_list_entities",
      "foreignKey": "tenant_id",
      "name": "call_list_entities",
      "macro": "has_many",
      "resource_name": "CallListEntity",
      "through": null
    },
    {
      "className": "CallList",
      "collectionName": "call_lists",
      "foreignKey": "tenant_id",
      "name": "call_lists",
      "macro": "has_many",
      "resource_name": "CallList",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "tenant_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "Comment",
      "collectionName": "comments",
      "foreignKey": "tenant_id",
      "name": "comments",
      "macro": "has_many",
      "resource_name": "Comment",
      "through": null
    },
    {
      "className": "CompetitionClassStep",
      "collectionName": "competition_class_steps",
      "foreignKey": "tenant_id",
      "name": "competition_class_steps",
      "macro": "has_many",
      "resource_name": "CompetitionClassStep",
      "through": null
    },
    {
      "className": "CompetitionSurvey",
      "collectionName": "competition_surveys",
      "foreignKey": "tenant_id",
      "name": "competition_surveys",
      "macro": "has_many",
      "resource_name": "CompetitionSurvey",
      "through": null
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "tenant_id",
      "name": "competitions",
      "macro": "has_many",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "tenant_id",
      "name": "contact_addresses",
      "macro": "has_many",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "ContactAssociate",
      "collectionName": "contact_associates",
      "foreignKey": "tenant_id",
      "name": "contact_associates",
      "macro": "has_many",
      "resource_name": "ContactAssociate",
      "through": null
    },
    {
      "className": "ContactGroupContact",
      "collectionName": "contact_group_contacts",
      "foreignKey": "tenant_id",
      "name": "contact_group_contacts",
      "macro": "has_many",
      "resource_name": "ContactGroupContact",
      "through": null
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "tenant_id",
      "name": "contact_groups",
      "macro": "has_many",
      "resource_name": "ContactGroup",
      "through": null
    },
    {
      "className": "ContactMergeRequest",
      "collectionName": "contact_merge_requests",
      "foreignKey": "tenant_id",
      "name": "contact_merge_requests",
      "macro": "has_many",
      "resource_name": "ContactMergeRequest",
      "through": null
    },
    {
      "className": "ContactPhotoSessionCurrent",
      "collectionName": "contact_photo_session_currents",
      "foreignKey": "tenant_id",
      "name": "contact_photo_session_currents",
      "macro": "has_many",
      "resource_name": "ContactPhotoSessionCurrent",
      "through": null
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "tenant_id",
      "name": "contact_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "tenant_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Conversation",
      "collectionName": "conversations",
      "foreignKey": "tenant_id",
      "name": "conversations",
      "macro": "has_many",
      "resource_name": "Conversation",
      "through": null
    },
    {
      "className": "TenantDomain",
      "collectionName": "tenant_domains",
      "foreignKey": "default_tenant_domain_id",
      "name": "default_tenant_domain",
      "macro": "belongs_to",
      "resource_name": "TenantDomain",
      "through": null
    },
    {
      "className": "ElectionPostContact",
      "collectionName": "election_post_contacts",
      "foreignKey": "tenant_id",
      "name": "election_post_contacts",
      "macro": "has_many",
      "resource_name": "ElectionPostContact",
      "through": null
    },
    {
      "className": "ElectionPostSchoolClass",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "election_post_school_classes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "tenant_id",
      "name": "election_posts",
      "macro": "has_many",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "tenant_id",
      "name": "elections",
      "macro": "has_many",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "tenant_id",
      "name": "element_feedback_options",
      "macro": "has_many",
      "resource_name": "ElementFeedbackOption",
      "through": null
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "tenant_id",
      "name": "element_feedbacks",
      "macro": "has_many",
      "resource_name": "ElementFeedback",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "tenant_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "Email",
      "collectionName": "emails",
      "foreignKey": "tenant_id",
      "name": "emails",
      "macro": "has_many",
      "resource_name": "Email",
      "through": null
    },
    {
      "className": "EmployeePrice",
      "collectionName": "employee_prices",
      "foreignKey": "tenant_id",
      "name": "employee_prices",
      "macro": "has_many",
      "resource_name": "EmployeePrice",
      "through": null
    },
    {
      "className": "FeedbackAnswer",
      "collectionName": "feedback_answers",
      "foreignKey": "tenant_id",
      "name": "feedback_answers",
      "macro": "has_many",
      "resource_name": "FeedbackAnswer",
      "through": null
    },
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "tenant_id",
      "name": "feedback_assignments",
      "macro": "has_many",
      "resource_name": "FeedbackAssignment",
      "through": null
    },
    {
      "className": "FeedbackElement",
      "collectionName": "feedback_elements",
      "foreignKey": "tenant_id",
      "name": "feedback_elements",
      "macro": "has_many",
      "resource_name": "FeedbackElement",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "tenant_id",
      "name": "feedback_steps",
      "macro": "has_many",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "FeedbackSurvey",
      "collectionName": "feedback_surveys",
      "foreignKey": "tenant_id",
      "name": "feedback_surveys",
      "macro": "has_many",
      "resource_name": "FeedbackSurvey",
      "through": null
    },
    {
      "className": "FinanceAccountFinanceDimensionValue",
      "collectionName": "finance_account_finance_dimension_values",
      "foreignKey": "tenant_id",
      "name": "finance_account_finance_dimension_values",
      "macro": "has_many",
      "resource_name": "FinanceAccountFinanceDimensionValue",
      "through": null
    },
    {
      "className": "FinanceAccountType",
      "collectionName": "finance_account_types",
      "foreignKey": "tenant_id",
      "name": "finance_account_types",
      "macro": "has_many",
      "resource_name": "FinanceAccountType",
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "tenant_id",
      "name": "finance_accounts",
      "macro": "has_many",
      "resource_name": "FinanceAccount",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "tenant_id",
      "name": "finance_dimension_values",
      "macro": "has_many",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "FinanceDimension",
      "collectionName": "finance_dimensions",
      "foreignKey": "tenant_id",
      "name": "finance_dimensions",
      "macro": "has_many",
      "resource_name": "FinanceDimension",
      "through": null
    },
    {
      "className": "Gender",
      "collectionName": "genders",
      "foreignKey": "tenant_id",
      "name": "genders",
      "macro": "has_many",
      "resource_name": "Gender",
      "through": null
    },
    {
      "className": "HighscoreClassStep",
      "collectionName": "highscore_class_steps",
      "foreignKey": "tenant_id",
      "name": "highscore_class_steps",
      "macro": "has_many",
      "resource_name": "HighscoreClassStep",
      "through": null
    },
    {
      "className": "HighscoreCommune",
      "collectionName": "highscore_communes",
      "foreignKey": "tenant_id",
      "name": "highscore_communes",
      "macro": "has_many",
      "resource_name": "HighscoreCommune",
      "through": null
    },
    {
      "className": "HighscoreCompetition",
      "collectionName": "highscore_competitions",
      "foreignKey": "tenant_id",
      "name": "highscore_competitions",
      "macro": "has_many",
      "resource_name": "HighscoreCompetition",
      "through": null
    },
    {
      "className": "HighscoreExcludedUser",
      "collectionName": "highscore_excluded_users",
      "foreignKey": "tenant_id",
      "name": "highscore_excluded_users",
      "macro": "has_many",
      "resource_name": "HighscoreExcludedUser",
      "through": null
    },
    {
      "className": "HighscoreGenerationSurvey",
      "collectionName": "highscore_generation_surveys",
      "foreignKey": "tenant_id",
      "name": "highscore_generation_surveys",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationSurvey",
      "through": null
    },
    {
      "className": "HighscoreGenerationTeam",
      "collectionName": "highscore_generation_teams",
      "foreignKey": "tenant_id",
      "name": "highscore_generation_teams",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationTeam",
      "through": null
    },
    {
      "className": "HighscoreGeneration",
      "collectionName": "highscore_generations",
      "foreignKey": "tenant_id",
      "name": "highscore_generations",
      "macro": "has_many",
      "resource_name": "HighscoreGeneration",
      "through": null
    },
    {
      "className": "HighscoreOrganization",
      "collectionName": "highscore_organizations",
      "foreignKey": "tenant_id",
      "name": "highscore_organizations",
      "macro": "has_many",
      "resource_name": "HighscoreOrganization",
      "through": null
    },
    {
      "className": "HighscoreRegion",
      "collectionName": "highscore_regions",
      "foreignKey": "tenant_id",
      "name": "highscore_regions",
      "macro": "has_many",
      "resource_name": "HighscoreRegion",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "tenant_id",
      "name": "highscores",
      "macro": "has_many",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "ICalendar",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "i_calendars",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "tenant_id",
      "name": "invoice_lines",
      "macro": "has_many",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "InvoicePaymentBambora",
      "collectionName": "invoice_payment_bamboras",
      "foreignKey": "tenant_id",
      "name": "invoice_payment_bamboras",
      "macro": "has_many",
      "resource_name": "InvoicePaymentBambora",
      "through": null
    },
    {
      "className": "InvoicePayment",
      "collectionName": "invoice_payments",
      "foreignKey": "tenant_id",
      "name": "invoice_payments",
      "macro": "has_many",
      "resource_name": "InvoicePayment",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "tenant_id",
      "name": "invoices",
      "macro": "has_many",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Jobler::Job",
      "collectionName": "jobler_jobs",
      "foreignKey": "tenant_id",
      "name": "jobs",
      "macro": "has_many",
      "resource_name": "JoblerJob",
      "through": null
    },
    {
      "className": "LockedField",
      "collectionName": "locked_fields",
      "foreignKey": "tenant_id",
      "name": "locked_fields",
      "macro": "has_many",
      "resource_name": "LockedField",
      "through": null
    },
    {
      "className": "LockedFinanceDimensionValue",
      "collectionName": "locked_finance_dimension_values",
      "foreignKey": "tenant_id",
      "name": "locked_finance_dimension_values",
      "macro": "has_many",
      "resource_name": "LockedFinanceDimensionValue",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "tenant_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "MessageRecipient",
      "collectionName": "message_recipients",
      "foreignKey": "tenant_id",
      "name": "message_recipients",
      "macro": "has_many",
      "resource_name": "MessageRecipient",
      "through": null
    },
    {
      "className": "Message",
      "collectionName": "messages",
      "foreignKey": "tenant_id",
      "name": "messages",
      "macro": "has_many",
      "resource_name": "Message",
      "through": null
    },
    {
      "className": "ModelEventType",
      "collectionName": "model_event_types",
      "foreignKey": "tenant_id",
      "name": "model_event_types",
      "macro": "has_many",
      "resource_name": "ModelEventType",
      "through": null
    },
    {
      "className": "ModelSearchGroup",
      "collectionName": "model_search_groups",
      "foreignKey": "tenant_id",
      "name": "model_search_groups",
      "macro": "has_many",
      "resource_name": "ModelSearchGroup",
      "through": null
    },
    {
      "className": "ModelSearchRule",
      "collectionName": "model_search_rules",
      "foreignKey": "tenant_id",
      "name": "model_search_rules",
      "macro": "has_many",
      "resource_name": "ModelSearchRule",
      "through": null
    },
    {
      "className": "ModelSearch",
      "collectionName": "model_searches",
      "foreignKey": "tenant_id",
      "name": "model_searches",
      "macro": "has_many",
      "resource_name": "ModelSearch",
      "through": null
    },
    {
      "className": "Navigation",
      "collectionName": "navigations",
      "foreignKey": "tenant_id",
      "name": "navigations",
      "macro": "has_many",
      "resource_name": "Navigation",
      "through": null
    },
    {
      "className": "Notification",
      "collectionName": "notifications",
      "foreignKey": "tenant_id",
      "name": "notifications",
      "macro": "has_many",
      "resource_name": "Notification",
      "through": null
    },
    {
      "className": "NumberOfStudentsCsv",
      "collectionName": "number_of_students_csvs",
      "foreignKey": "tenant_id",
      "name": "number_of_students_csvs",
      "macro": "has_many",
      "resource_name": "NumberOfStudentsCsv",
      "through": null
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "tenant_id",
      "name": "option_positions",
      "macro": "has_many",
      "resource_name": "OptionPosition",
      "through": null
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "tenant_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "Option",
      "through": null
    },
    {
      "className": "OrderDelivery",
      "collectionName": "order_deliveries",
      "foreignKey": "tenant_id",
      "name": "order_deliveries",
      "macro": "has_many",
      "resource_name": "OrderDelivery",
      "through": null
    },
    {
      "className": "OrderDeliveryShipmondo",
      "collectionName": "order_delivery_shipmondos",
      "foreignKey": "tenant_id",
      "name": "order_delivery_shipmondos",
      "macro": "has_many",
      "resource_name": "OrderDeliveryShipmondo",
      "through": null
    },
    {
      "className": "OrderGenerationOrder",
      "collectionName": "order_generation_orders",
      "foreignKey": "tenant_id",
      "name": "order_generation_orders",
      "macro": "has_many",
      "resource_name": "OrderGenerationOrder",
      "through": null
    },
    {
      "className": "OrderGeneration",
      "collectionName": "order_generations",
      "foreignKey": "tenant_id",
      "name": "order_generations",
      "macro": "has_many",
      "resource_name": "OrderGeneration",
      "through": null
    },
    {
      "className": "OrderLinePhoto",
      "collectionName": "order_line_photos",
      "foreignKey": "tenant_id",
      "name": "order_line_photos",
      "macro": "has_many",
      "resource_name": "OrderLinePhoto",
      "through": null
    },
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "tenant_id",
      "name": "order_lines",
      "macro": "has_many",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "tenant_id",
      "name": "orders",
      "macro": "has_many",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "OrganizationUserRelationship",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "organization_user_relationships",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "tenant_id",
      "name": "organizations",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "tenant_id",
      "name": "people",
      "macro": "has_many",
      "resource_name": "Person",
      "through": null
    },
    {
      "className": "PersonRole",
      "collectionName": "person_roles",
      "foreignKey": "tenant_id",
      "name": "person_roles",
      "macro": "has_many",
      "resource_name": "PersonRole",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "tenant_id",
      "name": "phone_numbers",
      "macro": "has_many",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "PhotoColor",
      "collectionName": "photo_colors",
      "foreignKey": "tenant_id",
      "name": "photo_colors",
      "macro": "has_many",
      "resource_name": "PhotoColor",
      "through": null
    },
    {
      "className": "PhotoPhotoType",
      "collectionName": "photo_photo_types",
      "foreignKey": "tenant_id",
      "name": "photo_photo_types",
      "macro": "has_many",
      "resource_name": "PhotoPhotoType",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "tenant_id",
      "name": "photo_products",
      "macro": "has_many",
      "resource_name": "PhotoProduct",
      "through": null
    },
    {
      "className": "PhotoSessionCsv",
      "collectionName": "photo_session_csvs",
      "foreignKey": "tenant_id",
      "name": "photo_session_csvs",
      "macro": "has_many",
      "resource_name": "PhotoSessionCsv",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContactTokenContact",
      "collectionName": "photo_session_group_contact_token_contacts",
      "foreignKey": "tenant_id",
      "name": "photo_session_group_contact_token_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContactTokenContact",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContactToken",
      "collectionName": "photo_session_group_contact_tokens",
      "foreignKey": "tenant_id",
      "name": "photo_session_group_contact_tokens",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContactToken",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "tenant_id",
      "name": "photo_session_group_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "tenant_id",
      "name": "photo_session_groups",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "tenant_id",
      "name": "photo_sessions",
      "macro": "has_many",
      "resource_name": "PhotoSession",
      "through": null
    },
    {
      "className": "PhotoSheetProductBox",
      "collectionName": "photo_sheet_product_boxes",
      "foreignKey": "tenant_id",
      "name": "photo_sheet_product_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductBox",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLineGeneration",
      "collectionName": "photo_sheet_product_order_line_generations",
      "foreignKey": "tenant_id",
      "name": "photo_sheet_product_order_line_generations",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLineGeneration",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "tenant_id",
      "name": "photo_sheet_product_order_lines",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "PhotoSheetProductSheetLayout",
      "collectionName": "photo_sheet_product_sheet_layouts",
      "foreignKey": "tenant_id",
      "name": "photo_sheet_product_sheet_layouts",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductSheetLayout",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "tenant_id",
      "name": "photo_sheet_products",
      "macro": "has_many",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "tenant_id",
      "name": "photo_types",
      "macro": "has_many",
      "resource_name": "PhotoType",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "tenant_id",
      "name": "photos",
      "macro": "has_many",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "PlanContactType",
      "collectionName": "plan_contact_types",
      "foreignKey": "tenant_id",
      "name": "plan_contact_types",
      "macro": "has_many",
      "resource_name": "PlanContactType",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "tenant_id",
      "name": "plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "tenant_id",
      "name": "products",
      "macro": "has_many",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "ProposalContact",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "proposal_contacts",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ProposalType",
      "collectionName": "proposal_types",
      "foreignKey": "tenant_id",
      "name": "proposal_types",
      "macro": "has_many",
      "resource_name": "ProposalType",
      "through": null
    },
    {
      "className": "ProposalVoteResult",
      "collectionName": "proposal_vote_results",
      "foreignKey": "tenant_id",
      "name": "proposal_vote_results",
      "macro": "has_many",
      "resource_name": "ProposalVoteResult",
      "through": null
    },
    {
      "className": "ProposalVoteToken",
      "collectionName": "proposal_vote_tokens",
      "foreignKey": "tenant_id",
      "name": "proposal_vote_tokens",
      "macro": "has_many",
      "resource_name": "ProposalVoteToken",
      "through": null
    },
    {
      "className": "ProposalVote",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "proposal_votes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Proposal",
      "collectionName": "proposals",
      "foreignKey": "tenant_id",
      "name": "proposals",
      "macro": "has_many",
      "resource_name": "Proposal",
      "through": null
    },
    {
      "className": "ReimbursementAttachment",
      "collectionName": "reimbursement_attachments",
      "foreignKey": "tenant_id",
      "name": "reimbursement_attachments",
      "macro": "has_many",
      "resource_name": "ReimbursementAttachment",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "tenant_id",
      "name": "reimbursements",
      "macro": "has_many",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "tenant_id",
      "name": "required_metadata",
      "macro": "has_many",
      "resource_name": "RequiredMetadatum",
      "through": null
    },
    {
      "className": "Jobler::Result",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "results",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "RoleAbility",
      "collectionName": "role_abilities",
      "foreignKey": "tenant_id",
      "name": "role_abilities",
      "macro": "has_many",
      "resource_name": "RoleAbility",
      "through": null
    },
    {
      "className": "RoleAbilityGroup",
      "collectionName": "role_ability_groups",
      "foreignKey": "tenant_id",
      "name": "role_ability_groups",
      "macro": "has_many",
      "resource_name": "RoleAbilityGroup",
      "through": null
    },
    {
      "className": "Role",
      "collectionName": "roles",
      "foreignKey": "tenant_id",
      "name": "roles",
      "macro": "has_many",
      "resource_name": "Role",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "tenant_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "SchoolElection",
      "collectionName": "school_elections",
      "foreignKey": "tenant_id",
      "name": "school_elections",
      "macro": "has_many",
      "resource_name": "SchoolElection",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "tenant_id",
      "name": "school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "SendingRule",
      "collectionName": "sending_rules",
      "foreignKey": "tenant_id",
      "name": "sending_rules",
      "macro": "has_many",
      "resource_name": "SendingRule",
      "through": null
    },
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "tenant_id",
      "name": "sheet_layout_boxes",
      "macro": "has_many",
      "resource_name": "SheetLayoutBox",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "tenant_id",
      "name": "sheet_layouts",
      "macro": "has_many",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "tenant_id",
      "name": "sheet_sizes",
      "macro": "has_many",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "ShowBox",
      "collectionName": "show_boxes",
      "foreignKey": "tenant_id",
      "name": "show_boxes",
      "macro": "has_many",
      "resource_name": "ShowBox",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "tenant_id",
      "name": "steps",
      "macro": "has_many",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "StudentCouncilMembership",
      "collectionName": "student_council_memberships",
      "foreignKey": "tenant_id",
      "name": "student_council_memberships",
      "macro": "has_many",
      "resource_name": "StudentCouncilMembership",
      "through": null
    },
    {
      "className": "StudentCouncil",
      "collectionName": "student_councils",
      "foreignKey": "tenant_id",
      "name": "student_councils",
      "macro": "has_many",
      "resource_name": "StudentCouncil",
      "through": null
    },
    {
      "className": "SubActivity",
      "collectionName": "sub_activities",
      "foreignKey": "tenant_id",
      "name": "sub_activities",
      "macro": "has_many",
      "resource_name": "SubActivity",
      "through": null
    },
    {
      "className": "SubjectRole",
      "collectionName": "subject_roles",
      "foreignKey": "tenant_id",
      "name": "subject_roles",
      "macro": "has_many",
      "resource_name": "SubjectRole",
      "through": null
    },
    {
      "className": "Subject",
      "collectionName": "subjects",
      "foreignKey": "tenant_id",
      "name": "subjects",
      "macro": "has_many",
      "resource_name": "Subject",
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "tenant_id",
      "name": "subscription_periods",
      "macro": "has_many",
      "resource_name": "SubscriptionPeriod",
      "through": null
    },
    {
      "className": "SubscriptionRenewalGeneration",
      "collectionName": "subscription_renewal_generations",
      "foreignKey": "tenant_id",
      "name": "subscription_renewal_generations",
      "macro": "has_many",
      "resource_name": "SubscriptionRenewalGeneration",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "tenant_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "SupplierSupportedPhotoQuality",
      "collectionName": "supplier_supported_photo_qualities",
      "foreignKey": "tenant_id",
      "name": "supplier_supported_photo_qualities",
      "macro": "has_many",
      "resource_name": "SupplierSupportedPhotoQuality",
      "through": null
    },
    {
      "className": "SupplierSupportedSheet",
      "collectionName": "supplier_supported_sheets",
      "foreignKey": "tenant_id",
      "name": "supplier_supported_sheets",
      "macro": "has_many",
      "resource_name": "SupplierSupportedSheet",
      "through": null
    },
    {
      "className": "Supplier",
      "collectionName": "suppliers",
      "foreignKey": "tenant_id",
      "name": "suppliers",
      "macro": "has_many",
      "resource_name": "Supplier",
      "through": null
    },
    {
      "className": "SurveyJudge",
      "collectionName": "survey_judges",
      "foreignKey": "tenant_id",
      "name": "survey_judges",
      "macro": "has_many",
      "resource_name": "SurveyJudge",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "tenant_id",
      "name": "surveys",
      "macro": "has_many",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "tenant_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tenant_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": null
    },
    {
      "className": "TeamApplication",
      "collectionName": "team_applications",
      "foreignKey": "tenant_id",
      "name": "team_applications",
      "macro": "has_many",
      "resource_name": "TeamApplication",
      "through": null
    },
    {
      "className": "TeamSurveyJudgeReview",
      "collectionName": "team_survey_judge_reviews",
      "foreignKey": "tenant_id",
      "name": "team_survey_judge_reviews",
      "macro": "has_many",
      "resource_name": "TeamSurveyJudgeReview",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "tenant_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "tenant_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "tenant_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "Template",
      "collectionName": "templates",
      "foreignKey": "tenant_id",
      "name": "templates",
      "macro": "has_many",
      "resource_name": "Template",
      "through": null
    },
    {
      "className": "TenantBamboraSetting",
      "collectionName": "tenant_bambora_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_bambora_setting",
      "macro": "has_one",
      "resource_name": "TenantBamboraSetting",
      "through": null
    },
    {
      "className": "TenantContactSetting",
      "collectionName": "tenant_contact_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_contact_setting",
      "macro": "has_one",
      "resource_name": "TenantContactSetting",
      "through": null
    },
    {
      "className": "TenantDomain",
      "collectionName": "tenant_domains",
      "foreignKey": "tenant_id",
      "name": "tenant_domains",
      "macro": "has_many",
      "resource_name": "TenantDomain",
      "through": null
    },
    {
      "className": "TenantInventioSetting",
      "collectionName": "tenant_inventio_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_inventio_setting",
      "macro": "has_one",
      "resource_name": "TenantInventioSetting",
      "through": null
    },
    {
      "className": "TenantOrderSetting",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "tenant_order_setting",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_id",
      "name": "tenant_photo_products",
      "macro": "has_many",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "TenantShipmondoSetting",
      "collectionName": "tenant_shipmondo_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_shipmondo_setting",
      "macro": "has_one",
      "resource_name": "TenantShipmondoSetting",
      "through": null
    },
    {
      "className": "TenantShopSetting",
      "collectionName": "tenant_shop_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_shop_setting",
      "macro": "has_one",
      "resource_name": "TenantShopSetting",
      "through": null
    },
    {
      "className": "TenantUniSetting",
      "collectionName": "tenant_uni_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_uni_setting",
      "macro": "has_one",
      "resource_name": "TenantUniSetting",
      "through": null
    },
    {
      "className": "UniActiveCode",
      "collectionName": "uni_active_codes",
      "foreignKey": "tenant_id",
      "name": "uni_active_codes",
      "macro": "has_many",
      "resource_name": "UniActiveCode",
      "through": null
    },
    {
      "className": "UniOwnerCode",
      "collectionName": "uni_owner_codes",
      "foreignKey": "tenant_id",
      "name": "uni_owner_codes",
      "macro": "has_many",
      "resource_name": "UniOwnerCode",
      "through": null
    },
    {
      "className": "UniTypeThree",
      "collectionName": "uni_type_threes",
      "foreignKey": "tenant_id",
      "name": "uni_type_threes",
      "macro": "has_many",
      "resource_name": "UniTypeThree",
      "through": null
    },
    {
      "className": "UniTypeTwo",
      "collectionName": "uni_type_twos",
      "foreignKey": "tenant_id",
      "name": "uni_type_twos",
      "macro": "has_many",
      "resource_name": "UniTypeTwo",
      "through": null
    },
    {
      "className": "UniUnitType",
      "collectionName": "uni_unit_types",
      "foreignKey": "tenant_id",
      "name": "uni_unit_types",
      "macro": "has_many",
      "resource_name": "UniUnitType",
      "through": null
    },
    {
      "className": "UserElement",
      "collectionName": "user_elements",
      "foreignKey": "tenant_id",
      "name": "user_elements",
      "macro": "has_many",
      "resource_name": "UserElement",
      "through": null
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "tenant_id",
      "name": "user_steps",
      "macro": "has_many",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "tenant_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "VoteElectionPostContactResult",
      "collectionName": "vote_election_post_contact_results",
      "foreignKey": "tenant_id",
      "name": "vote_election_post_contact_results",
      "macro": "has_many",
      "resource_name": "VoteElectionPostContactResult",
      "through": null
    },
    {
      "className": "VoteElectionPostContact",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "vote_election_post_contacts",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "VoteElectionPostResult",
      "collectionName": "vote_election_post_results",
      "foreignKey": "tenant_id",
      "name": "vote_election_post_results",
      "macro": "has_many",
      "resource_name": "VoteElectionPostResult",
      "through": null
    },
    {
      "className": "VoteToken",
      "collectionName": "vote_tokens",
      "foreignKey": "tenant_id",
      "name": "vote_tokens",
      "macro": "has_many",
      "resource_name": "VoteToken",
      "through": null
    },
    {
      "className": "Vote",
      "collectionName": null,
      "foreignKey": "tenant_id",
      "name": "votes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "children_count",
      "column": {
        "default": 0,
        "name": "children_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "default_tenant_domain_id",
      "column": {
        "default": null,
        "name": "default_tenant_domain_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "depth",
      "column": {
        "default": 0,
        "name": "depth",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "lft",
      "column": {
        "default": null,
        "name": "lft",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "parent_id",
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "reimbursements_counter",
      "column": {
        "default": 0,
        "name": "reimbursements_counter",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "rgt",
      "column": {
        "default": null,
        "name": "rgt",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantDomain",
      "collectionName": "tenant_domains",
      "foreignKey": "default_tenant_domain_id",
      "name": "default_tenant_domain",
      "macro": "belongs_to",
      "resource_name": "TenantDomain",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantBamboraSetting",
      "collectionName": "tenant_bambora_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_bambora_setting",
      "macro": "has_one",
      "resource_name": "TenantBamboraSetting",
      "through": null
    },
    {
      "className": "TenantContactSetting",
      "collectionName": "tenant_contact_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_contact_setting",
      "macro": "has_one",
      "resource_name": "TenantContactSetting",
      "through": null
    },
    {
      "className": "TenantDomain",
      "collectionName": "tenant_domains",
      "foreignKey": "tenant_id",
      "name": "tenant_domains",
      "macro": "has_many",
      "resource_name": "TenantDomain",
      "through": null
    },
    {
      "className": "TenantInventioSetting",
      "collectionName": "tenant_inventio_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_inventio_setting",
      "macro": "has_one",
      "resource_name": "TenantInventioSetting",
      "through": null
    },
    {
      "className": "TenantShipmondoSetting",
      "collectionName": "tenant_shipmondo_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_shipmondo_setting",
      "macro": "has_one",
      "resource_name": "TenantShipmondoSetting",
      "through": null
    },
    {
      "className": "TenantShopSetting",
      "collectionName": "tenant_shop_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_shop_setting",
      "macro": "has_one",
      "resource_name": "TenantShopSetting",
      "through": null
    },
    {
      "className": "TenantUniSetting",
      "collectionName": "tenant_uni_settings",
      "foreignKey": "tenant_id",
      "name": "tenant_uni_setting",
      "macro": "has_one",
      "resource_name": "TenantUniSetting",
      "through": null
    }
  ],
  "paramKey": "tenant",
  "primaryKey": "id"
}

/** Frontend model for Tenant. */
export default class Tenant extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  defaultTenantDomainId() {
    return this.readAttributeUnderscore("default_tenant_domain_id")
  }

  /** @returns {boolean} */
  hasDefaultTenantDomainId() {
    const value = this.defaultTenantDomainId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  parentId() {
    return this.readAttributeUnderscore("parent_id")
  }

  /** @returns {boolean} */
  hasParentId() {
    const value = this.parentId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static adminCreate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "admin_create",
        collectionName: "tenants",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./tenant.js").default>} */
  children() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./tenant.js").default>>} */
  loadChildren() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./tenant.js").default>>} */
  ensureChildrenLoaded() {
    return this.ensureAssociationLoaded("children")
  }

  /** @returns {import("./tenant-domain.js").default | null} */
  defaultTenantDomain() {
    return this._readBelongsToReflection({modelClass: TenantDomain, reflectionName: "default_tenant_domain"})
  }

  /** @returns {Promise<import("./tenant-domain.js").default | null>} */
  loadDefaultTenantDomain() {
    if (!("defaultTenantDomainId" in this)) throw new Error("Foreign key method wasn't defined: defaultTenantDomainId")

    const id = this.defaultTenantDomainId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "default_tenant_domain",
        model: this,
        modelClass: TenantDomain
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-domain.js").default | null>} */
  ensureDefaultTenantDomainLoaded() {
    return this.ensureAssociationLoaded("default_tenant_domain")
  }

  /** @returns {import("./tenant.js").default | null} */
  parent() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "parent"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadParent() {
    if (!("parentId" in this)) throw new Error("Foreign key method wasn't defined: parentId")

    const id = this.parentId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "parent",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureParentLoaded() {
    return this.ensureAssociationLoaded("parent")
  }

  /** @returns {import("./tenant-bambora-setting.js").default | null} */
  tenantBamboraSetting() {
    return this._readHasOneReflection({modelClass: TenantBamboraSetting, reflectionName: "tenant_bambora_setting"})
  }

  /** @returns {Promise<import("./tenant-bambora-setting.js").default | null>} */
  loadTenantBamboraSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["tenant_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "tenant_bambora_setting",
        model: this,
        modelClass: TenantBamboraSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-bambora-setting.js").default | null>} */
  ensureTenantBamboraSettingLoaded() {
    return this.ensureAssociationLoaded("tenant_bambora_setting")
  }

  /** @returns {import("./tenant-contact-setting.js").default | null} */
  tenantContactSetting() {
    return this._readHasOneReflection({modelClass: TenantContactSetting, reflectionName: "tenant_contact_setting"})
  }

  /** @returns {Promise<import("./tenant-contact-setting.js").default | null>} */
  loadTenantContactSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["tenant_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "tenant_contact_setting",
        model: this,
        modelClass: TenantContactSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-contact-setting.js").default | null>} */
  ensureTenantContactSettingLoaded() {
    return this.ensureAssociationLoaded("tenant_contact_setting")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./tenant-domain.js").default>} */
  tenantDomains() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["tenant_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "tenant_domains",
        model: this,
        modelClass: TenantDomain
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./tenant-domain.js").default>>} */
  loadTenantDomains() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["tenant_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "tenant_domains",
        model: this,
        modelClass: TenantDomain
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./tenant-domain.js").default>>} */
  ensureTenantDomainsLoaded() {
    return this.ensureAssociationLoaded("tenant_domains")
  }

  /** @returns {import("./tenant-inventio-setting.js").default | null} */
  tenantInventioSetting() {
    return this._readHasOneReflection({modelClass: TenantInventioSetting, reflectionName: "tenant_inventio_setting"})
  }

  /** @returns {Promise<import("./tenant-inventio-setting.js").default | null>} */
  loadTenantInventioSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["tenant_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "tenant_inventio_setting",
        model: this,
        modelClass: TenantInventioSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-inventio-setting.js").default | null>} */
  ensureTenantInventioSettingLoaded() {
    return this.ensureAssociationLoaded("tenant_inventio_setting")
  }

  /** @returns {import("./tenant-shipmondo-setting.js").default | null} */
  tenantShipmondoSetting() {
    return this._readHasOneReflection({modelClass: TenantShipmondoSetting, reflectionName: "tenant_shipmondo_setting"})
  }

  /** @returns {Promise<import("./tenant-shipmondo-setting.js").default | null>} */
  loadTenantShipmondoSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["tenant_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "tenant_shipmondo_setting",
        model: this,
        modelClass: TenantShipmondoSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-shipmondo-setting.js").default | null>} */
  ensureTenantShipmondoSettingLoaded() {
    return this.ensureAssociationLoaded("tenant_shipmondo_setting")
  }

  /** @returns {import("./tenant-shop-setting.js").default | null} */
  tenantShopSetting() {
    return this._readHasOneReflection({modelClass: TenantShopSetting, reflectionName: "tenant_shop_setting"})
  }

  /** @returns {Promise<import("./tenant-shop-setting.js").default | null>} */
  loadTenantShopSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["tenant_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "tenant_shop_setting",
        model: this,
        modelClass: TenantShopSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-shop-setting.js").default | null>} */
  ensureTenantShopSettingLoaded() {
    return this.ensureAssociationLoaded("tenant_shop_setting")
  }

  /** @returns {import("./tenant-uni-setting.js").default | null} */
  tenantUniSetting() {
    return this._readHasOneReflection({modelClass: TenantUniSetting, reflectionName: "tenant_uni_setting"})
  }

  /** @returns {Promise<import("./tenant-uni-setting.js").default | null>} */
  loadTenantUniSetting() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["tenant_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "tenant_uni_setting",
        model: this,
        modelClass: TenantUniSetting
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-uni-setting.js").default | null>} */
  ensureTenantUniSettingLoaded() {
    return this.ensureAssociationLoaded("tenant_uni_setting")
  }
}
